<template>

    <li class="call-item">
      <div class="call-details">
        <div class="call-item-icon">
          <v-svg class="voxo-green" sprite="call-inbound" v-if="callDirection === 'INBOUND' && callAnswered"/>
          <v-svg class="voxo-red" sprite="call-inbound" v-if="callDirection === 'INBOUND' && !callAnswered"/>
          <v-svg class="voxo-green" sprite="call-outbound" v-if="callDirection === 'OUTBOUND' && callAnswered"/>
          <v-svg class="voxo-red" sprite="call-outbound" v-if="callDirection === 'OUTBOUND' && !callAnswered"/>
        </div>
        <div class="call-source">
          <div class="call-number">
            {{numberFormatter(callNumber)}}
          </div>
          <div class="call-name">
            {{callerId}}
          </div>
        </div>
      </div>
      <div class="call-info">
        <div class="call-time">
          {{dateFormatter(startTime)}}
        </div>
        <div class="call-duration">
          {{durationFormatter(talkTime)}}
        </div>
      </div>
      <el-button
        class="table-action-button"
        @click="dialCall"
        style="box-shadow: none;">
        <v-svg class="voxo-green" sprite="phone"/>
      </el-button>
    </li>

</template>

<script>

  import moment from 'moment-timezone';
  import {globalEventBus} from "@/globalEventBus";
  import {phoneNumberFormatter} from "@/globals/globals";
  import feathersClient from "@/feathers/feathers-client";

  export default {
    name: 'CallView',
    props: {
      startTime: {required: true},
      callNumber: {required: true},
      callerId: {required: true},
      talkTime: {required: true},
      direction: {required: true},
      disposition: {required: true}
    },
    computed: {
      callDirection(){
        if(this.direction === 'inbound') return 'INBOUND';
        if(this.direction === 'outbound') return 'OUTBOUND';
      },
      callAnswered(){
        if(this.disposition === 'ANSWERED') return true;
      },
      softphoneEnabled(){
        return this.$store.state.softphoneEnabled;
      },
      userOffsetMinutes(){
        return this.$store.state.userTimeOffset;
      },
      user(){
        return this.$store.state.auth.user;
      }
    },
    methods: {
      durationFormatter(time){
        const hours = Math.floor(time / 3600);
        const remainderSeconds = time%3600;
        const minutes = Math.floor(remainderSeconds / 60);
        const seconds = Math.round(remainderSeconds%60);

        if (hours > 0) return hours + 'hr ' + minutes + 'm';
        if (minutes > 0) return minutes + 'm';
        if (seconds > 0) return seconds + 's';
        return '0';
      },
      dateFormatter(time) {
        const minuteOffset = Math.abs(this.userOffsetMinutes);
        const {timezone} = this.user;

        //need to figure out what 'Today is in the user's time zone instead of taking native 'moment'
        const dayToday = moment.tz(timezone).format('YYYY-MM-DD')

        //day call occured using server timestamp and user offset
        const dayCall = this.userOffsetMinutes < 0
          ? moment(time).subtract(minuteOffset, 'minutes').format('YYYY-MM-DD')
          : moment(time).add(minuteOffset, 'minutes').format('YYYY-MM-DD');

        const dayDifference = moment.duration(moment(dayToday).diff(moment(dayCall))).asDays();

        //call happened today
        if(dayDifference === 0){
          return this.userOffsetMinutes < 0
            ? moment(time).subtract(minuteOffset, 'minutes').format('h:mm A')
            : moment(time).add(minuteOffset, 'minutes').format('h:mm A');
        }

        //call happened yesterday
        if(dayDifference === 1) return 'Yesterday';

        //call happened in the recent week
        if(dayDifference >= 2 && dayDifference <= 6){
          return this.userOffsetMinutes < 0
            ? moment(time).subtract(minuteOffset, 'minutes').format('dddd')
            : moment(time).add(minuteOffset, 'minutes').format('dddd');
        }

        //call is older than a week
        return this.userOffsetMinutes < 0
          ? moment(time).subtract(minuteOffset, 'minutes').format('M/D')
          : moment(time).add(minuteOffset, 'minutes').format('M/D');
      },
      numberFormatter(number) {
        return phoneNumberFormatter(number);
      },
      dialCall(){

        if(this.softphoneEnabled) {
          globalEventBus.$emit('dialSoftphone', this.callNumber);
        } else {
          const {peerName} = this.user.myExtension;
          feathersClient.service('nats-actions-handler').create({
            reqType: 'notifyOriginate',
            number: this.callNumber,
            peerName
          });
        }
      }
    }
  }

</script>
